var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeIllness = function SvgEyeIllness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eye-illness_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#83E3ED",
    d: "M18 3.375c8.08 0 14.625 6.55 14.625 14.625S26.081 32.625 18 32.625 3.375 26.081 3.375 18 9.925 3.375 18 3.375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008C95",
    d: "M26.837 19.685C25.86 8.673 25.34.855 20.03 10.588a20.4 20.4 0 0 0-3.297-.385 20.4 20.4 0 0 0-3.298.385c-4.025-7.27-5.304-5.123-6.217 2.79-.527 5.67-.99 7.31.071 9.225 1.755 3.632 7.2 7.65 9.887 7.22 3.767-.54 10.08-6.152 9.662-10.138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M26.839 19.685c-.02-.213-.033-.335-.058-.54-.45 2.352-2.36 4.692-4.841 6.64-2.115 1.607-4.114 2.52-5.58 2.36-3.626-.495-9.084-5.362-9.669-9-.9 4.48 6.198 10.42 9.855 10.703 3.555.18 10.755-5.966 10.293-10.163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00686A",
    d: "M26.846 19.691c-.978-11.018-1.498-18.835-6.808-9.103a22 22 0 0 0-3.298-.385 22 22 0 0 0-3.298.385C7.046-1.632 7.36 15.056 6.66 19.383c-.43 3.06 2.488 6.255 4.937 8.145-1.62-1.685-2.398-3.62-3.15-5.522-1.215-2.88-.257-4.108 2.192-5.195 1.067-2.16.47-1.69 2.687-2.153.9-1.607 1.067-1.28 2.578-.187.675.482-.508-1.948.823-1.89 1.376 0 .11 2.417.823 1.89 2.565-2.038 1.82-.128 2.732.277 2.938.135 1.543 1.35 2.713 2.198 3.163 1.087 2.816 3.42 1.832 5.49a14.4 14.4 0 0 1-2.97 5.085c2.456-1.883 5.175-4.905 4.97-7.843l.012.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M12.4 11.128c-3.96-8.357-3.723.482-4.244 4.25a12.8 12.8 0 0 1 4.243-4.25M21.078 11.128c3.96-8.364 3.735.47 4.243 4.236a12.56 12.56 0 0 0-4.243-4.236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M13.227 16.528c.701 0 1.267.566 1.267 1.267 0 .7-.566 1.266-1.267 1.266-.7 0-1.266-.566-1.266-1.266s.566-1.267 1.266-1.267M20.321 16.528c-.7 0-1.266.566-1.266 1.267 0 .7.565 1.266 1.266 1.266.7 0 1.266-.566 1.266-1.266s-.565-1.267-1.266-1.267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002E3E",
    d: "M20.3 24.089c-1.549-2.475-3.304-1.318-3.047-2.295 0-.386.078-1.003-.598-.939-.565.116-.315.958-.372 1.35-3.723.52-3.453 3.478-2.173 2.289.7-1.35 2.95-1.69 4.262-.984.63.206 1.832 2.353 1.916.579z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M17.929 19.022c-4.892-.784-2.893 2.771-1.19 2.687 1.608.084 2.745-2.192 1.19-2.687M13.227 16.528c.701 0 1.267.566 1.267 1.267 0 .7-.566 1.266-1.267 1.266-.7 0-1.266-.566-1.266-1.266s.566-1.267 1.266-1.267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002E3E",
    d: "m26.434 20.553 1.858 2.025-.18 1.292h-1.235l-1.857-2.025 1.414-1.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002E3E",
    d: "M27.983 17.622a5.866 5.866 0 0 1-6.132 5.586 5.86 5.86 0 0 1-5.587-6.133 5.86 5.86 0 0 1 6.133-5.586 5.873 5.873 0 0 1 5.586 6.133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M27.033 17.577a4.894 4.894 0 1 1-4.667-5.111h.006a4.893 4.893 0 0 1 4.661 5.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002E3E",
    d: "m28.85 27.463-2.784-3.073a.464.464 0 0 1 .032-.649l2.096-1.91a.465.465 0 0 1 .65.033l1.838 2.025.617.675.334.366c.502.585.463 1.46-.096 2l-.675.623a1.465 1.465 0 0 1-2.006-.096"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008C95",
    d: "m28.754 27.354-.617-.675.675-.623a.46.46 0 0 1 .655.032.46.46 0 0 1-.032.655l-.681.617zM30.155 25.413c-.122-.058-.116-.231-.11-.36a.75.75 0 0 1 .142-.347l.675-.617.617.675-.675.623a.43.43 0 0 1-.597.071c-.02-.013-.039-.032-.052-.045"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#83E3ED",
    d: "M25.998 17.531a3.86 3.86 0 0 1-4.037 3.684 3.86 3.86 0 0 1-3.683-4.037 3.86 3.86 0 0 1 4.037-3.684h.006a3.865 3.865 0 0 1 3.677 4.037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    d: "M22.153 16.265c2.553.083 2.347 2.063 0 2.102-2.552-.084-2.333-2.064 0-2.102"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eye-illness_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.375 3.375h29.25v29.25H3.375z"
  })))));
};
export default SvgEyeIllness;